export default {
  id: null,
  empresaID: null,
  codigo: null,
  descricao: null,
  tipo: null,
  ordem: 0,
  resumo: false,
  geraInformacaoAtualizacao: false,
  descricaoInformacaoAtualizacao: null,
  naoSobrepoeInformacoesObraCandidato: false,
  totalizarColuna: false,
  bloqueiaRetroativo: false,
  qtdDiasRetroativo: 0,
  tipoDados: null,
  itemLinhaPrincipal: false,
  mostrarPci: false,
  tamanhoTexto: null,
  pciModeloItemIDPai: null,
  pciModeloItemEspelho: null,
  pciModeloItemIDEspelho: null,
  pciModeloItemIDInicioObra: null,
  pciModeloItemIDTerminoObra: null,
  tipoEspelho: null,
  tipoEspelhoCond: null,
  pciModeloItemIDEspelhoCond: null,
  origemDatasParalisacao: 0,
  tipoParalisacao: null,
  tipoAT: null,
  servicosAt: [],
  formula: [],
  formulaSmart: [],
  status: 1,
  valores: [],
  validacoes: [],
  automatizacoes: [],
  children: [],
  pais: '',
  itemFinanc: false,
  calcFormato: 0,
  calcExpressao: null,
  calcVariaveis: [],
  paralisacoes: []
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/pcimodeloitemmodel.js